import { LimitType } from "@/modules/limit-control/domain/entities/LimitControlEntity";
import { Client, ClientInstrument, ClientOrderCreateRequest, ClientOrderEntity, ClientOrderStatusEnum, ClientOrderTypeEnum, RentTypeEnum } from "../domain/entities/ClientOrdersEntity";
import { LimitTypeEnum } from "@/modules/orders/domain/entities/OrdersEntity";


export const enrichClientOrder = (
    request: ClientOrderCreateRequest,
    id: string,
    createdAt: Date,
    updatedAt: Date | null,
    context: {
        clients?: Client[];
        instruments?: ClientInstrument[];
    }
): ClientOrderEntity | null => {
    const {
        clients = [],
        instruments = [],
    } = context;

    const client = clients.find((c) => c.identificacion === request.clientIdentification);
    const instrument = instruments.find((ins) => ins.id.toString() === request.instrument);

    if (!client || !instrument) return null;

    return {
        id,
        client,
        instrument,
        quantity: request.quantity,
        rate: request.rate,
        value: request.value,
        createdAt,
        updatedAt,
        orderType: request.orderType as ClientOrderTypeEnum,
        rentType: request.rentType as RentTypeEnum,
        status: request.status as ClientOrderStatusEnum,
        confirmNumber: request.confirmNumber,
        limitPrice: request.limitPrice,
        limitType: request.limitType as LimitTypeEnum,
    };
}


export const mapClientOrderToFormValues = (entity?: ClientOrderEntity) =>
({
    id: entity?.id.toString() ?? "",
    client: entity?.client?.identificacion ?? "",
    clientIdentification: entity?.client?.identificacion ?? "",
    clientIdentificationType: entity?.client?.tipoIdentificacion ?? "",
    orderType: entity ? entity.orderType === ClientOrderTypeEnum.COMPRA : true,
    rentType: entity?.rentType ?? RentTypeEnum.RF, // Use entity value or default to Renta Fija
    status: entity?.status ?? undefined,
    instrument: entity?.instrument.id.toString() ?? "",
    quantity: entity?.quantity ?? 0,
    rate: entity?.rate ?? 0,
    value: entity?.value ?? 0,
    confirmNumber: entity?.confirmNumber ?? '',
    limitPrice: entity?.limitPrice ?? 0,
    limitType: entity ? entity.limitType === LimitTypeEnum.MERCADO : true, // Use entity value or default to Renta Fija
});
